var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDefaultAvatarG = function SvgDefaultAvatarG(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    style: {
      enableBackground: "new 0 0 80 80"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.1 55.8c6.4 0 11.3-3.1 12.9-8.1.3-.9.5-2.5 1-2.9 1.9-.1 2.9-.4 2.9-1.3 0-1.2-2.4-1.6-6.6-1.6s-6.6.4-6.6 1.6c0 .9 1.1 1.3 3.9 1.3.9.2 1.2 1 1.2 1.9 0 3.2-3.1 5.8-7.5 5.8-6.9 0-11.3-6.6-11.3-13.6 0-6.5 3.8-11.3 9.7-11.3 4 0 7.9 2.2 9.1 5.8.6 1.7 1.2 3 2.1 3 1.1 0 1.6-1.3 1.6-3.3 0-3.2-1-6.9-2.7-6.9-.8 0-1 .5-1.7.5-.3 0-.7-.1-1.4-.5-1.8-.8-4-1.6-6.8-1.6-8.6 0-15.3 6.6-15.3 15.7-.1 8.9 6.5 15.5 15.5 15.5z"
  })));
};
export default SvgDefaultAvatarG;